<template>
    <table style="width:100%;">
    <tr><td style="vertical-align:middle;"><v-icon>work_outline</v-icon> / <v-icon>person_outline</v-icon></td><td style="text-align:right;">Baggage</td><td style="text-align:right;">Carry on</td></tr>
    <tr v-for="(bag,index) in segmentBagInfo" :key="'bagInfoD_'+index">
        <td>{{bag.pax}}</td>
        <td style="text-align:right;">{{bag.baggage }}</td>
        <td style="text-align:right;">{{bag.carryOn}}</td>
    </tr>
    </table>  
</template>

<script>
export default {
    props:['segmentBagInfo'],
    data(){
        return {
            
        }
    }
}
</script>

<style>

</style>